import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons";

const BanCircleIcon = () => {
  return <FontAwesomeIcon icon={faBan} />;
};

export default BanCircleIcon;
